export class ResToken {
    cdCentrus: number;
    idTokenAcesso: number;
    dsTokenAcesso: string;
    dhInclusao: Date;
    dsEmail: string;
    noFuncao: string;
    constructor(
    ) {}
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/res-token.modul.ts